import { configureStore } from "@reduxjs/toolkit";
import thunkMiddleware from "redux-thunk";
import homeReducer from "../slices/homeSlice";
import servicesReducer from "../slices/servicesSlice";
import eventsReducer from "../slices/eventsSlice";
import activisionsReducer from "../slices/activisionsSlice";
import partnersReducer from "../slices/partnersSlice";
import projectsReducer from "../slices/projectsSlice";
import addonsReducer from "../slices/addonsSlice";
import whatIsNewReducer from "../slices/whatIsNewSlice";
import quotationsReducer from "../slices/quotationsSlice";
import contactsReducer from "../slices/contactsSlice";
import footerReducer from "../slices/footerSlice";
import logsReducer from "../slices/logsSlice";

const store = configureStore({
  reducer: {
    home: homeReducer,
    services: servicesReducer,
    events: eventsReducer,
    activisions: activisionsReducer,
    projects: projectsReducer,
    addons: addonsReducer,
    whatIsNew: whatIsNewReducer,
    partners: partnersReducer,
    quotations: quotationsReducer,
    contacts: contactsReducer,
    footer: footerReducer,
    logs: logsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(thunkMiddleware),
  devTools: process.env.NODE_ENV === "production" ? false : true,
});

export default store;
